<template>
  <div class="banner" :style="bannerStyle">
    <div class="slides">
      <div
        class="slide"
        v-for="(s, i) in slides"
        :key="i"
        :class="{ active: i === index }"
      >
        <img class="bg" :src="s.bg" alt="Banner" loading="eager" />
        <div class="title">{{ s.title }}</div>
        <p class="subtitle">{{ s.subtitle }}</p>
        <Group151 class="bar" :count="slides.length" :active="index" @select="go" />
      </div>
    </div>
    
  </div>
</template>

<script>
import Group151 from "./Group151.vue";
import { getBanner } from "../directus/api.js";

export default {
  name: "BannerCarousel",
  components: { Group151 },
  data() {
    return {
      index: 0,
      timer: null,
      interval: 5000,
      ratio: 1080 / 1920,
      slides: [
        {
          bg: "/static/img/mask-group.png",
          title: "提升石家庄基础教育水平",
          subtitle: "Improve the level of basic education in Shijiazhuang",
        },
        {
          bg: "/static/img/mask-group-1.png",
          title: "提升石家庄基础教育水平",
          subtitle: "Improve the level of basic education in Shijiazhuang",
        },
      ],
    };
  },
  mounted() {
    this.start();
    this.updateRatio();
    getBanner().then((list) => {
      if (Array.isArray(list) && list.length > 0) {
        this.stop();
        this.slides = list.filter((item) => item && item.bg);
        this.index = 0;
        this.updateRatio();
        this.start();
      }
    }).catch(() => {});
  },
  beforeDestroy() {
    this.stop();
  },
  watch: {
    index() {
      this.updateRatio();
    },
  },
  methods: {
    start() {
      this.stop();
      this.timer = setInterval(this.next, this.interval);
    },
    stop() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    next() {
      if (!this.slides.length) return;
      this.index = (this.index + 1) % this.slides.length;
    },
    go(i) {
      this.index = i;
      this.start();
    },
    updateRatio() {
      const img = new Image();
      img.onload = () => {
        if (img.naturalWidth && img.naturalHeight) {
          this.ratio = img.naturalHeight / img.naturalWidth;
        }
      };
      const slide = this.slides[this.index];
      if (slide && slide.bg) img.src = slide.bg;
    },
  },
  computed: {
    bannerStyle() {
      return {
        paddingTop: (this.ratio * 100) + "%",
      };
    },
  },
};
</script>

<style>
.banner {
  position: relative;
  width: 100%;
  min-height: 280px;
}

.slides {
  position: absolute;
  inset: 0;
}

.slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transform: scale(1.02);
  transition: opacity 500ms ease, transform 800ms ease;
}

.slide.active {
  opacity: 1;
  transform: scale(1);
}

.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.title {
  position: absolute;
  left: 9.64%;
  top: 42.31%;
  color: #ffffff;
  font-family: "PingFang SC-Semibold", Helvetica;
  font-size: 64px;
  letter-spacing: 3.2px;
  line-height: 96px;
  animation: fadeUp 600ms ease both;
}

.subtitle {
  position: absolute;
  left: 9.64%;
  top: 52.13%;
  color: #ffffff;
  font-family: "Poppins", Helvetica;
  font-size: 32px;
  font-weight: 300;
  letter-spacing: 1.6px;
  line-height: 48px;
  animation: fadeUp 700ms ease both;
}

.bar {
  position: absolute !important;
  left: 9.64% !important;
  top: 91.48% !important;
}

@media (max-width: 768px) {
  .banner {
    min-height: 360px;
  }

  .title {
    font-size: 34px;
    left: 8%;
    letter-spacing: 0;
    line-height: 46px;
    max-width: 84%;
    top: 38%;
  }

  .subtitle {
    font-size: 17px;
    left: 8%;
    letter-spacing: 0;
    line-height: 26px;
    max-width: 84%;
    top: 56%;
  }

  .bar {
    left: 8% !important;
  }
}


@keyframes fadeUp {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
